import { fromJS } from 'immutable'
import { handleActions } from 'redux-actions'

import * as Actions from 'actions/prompt_history'
import * as AppActions from 'actions/app'
import {
  prependPromptHistoryEntry,
  removePromptHistoryEntryById
} from 'utils/prompt_history'

const defaultKeyState = fromJS({
  entries: [],
  loading: false
})

export const initialState = fromJS({
  byKey: {}
})

const setKeyState = (state, key, keyState) => state.setIn(['byKey', key], keyState)

export default handleActions({
  [Actions.fetchPromptHistoryStart]: (state, { payload: { key } }) => setKeyState(
    state,
    key,
    (state.getIn(['byKey', key]) || defaultKeyState).set('loading', true)
  ),
  [Actions.fetchPromptHistorySuccess]: (state, { payload: { key, entries } }) => setKeyState(
    state,
    key,
    fromJS({
      entries,
      loading: false
    })
  ),
  [Actions.fetchPromptHistoryError]: (state, { payload: { key } }) => setKeyState(
    state,
    key,
    fromJS({
      entries: [],
      loading: false
    })
  ),
  [Actions.createPromptHistoryEntrySuccess]: (state, { payload: { key, entry, limit } }) => {
    const entries = state.getIn(['byKey', key, 'entries'], fromJS([])).toJS()

    return setKeyState(
      state,
      key,
      fromJS({
        entries: prependPromptHistoryEntry(entries, entry, limit),
        loading: false
      })
    )
  },
  [Actions.deletePromptHistoryEntrySuccess]: (state, { payload: { key, id } }) => {
    const entries = state.getIn(['byKey', key, 'entries'], fromJS([])).toJS()

    return setKeyState(
      state,
      key,
      fromJS({
        entries: removePromptHistoryEntryById(entries, id),
        loading: false
      })
    )
  },
  [Actions.clearPromptHistorySuccess]: (state, { payload: { key } }) => setKeyState(
    state,
    key,
    fromJS({
      entries: [],
      loading: false
    })
  ),
  [AppActions.resetState]: () => initialState
}, initialState)
